export default __webpack_public_path__ + "static/media/vision-section-06.0f768fbb.png";